import { Actions, AvailableModalActions, Error } from './store';
import { Nullable } from 'utils/types';
import { ValidationError as PepperValidationError } from 'modules/cm/pages/CaseDetailsPage/Pepper/errors/PepperValidationError';

/* Send data actions */
export const setSendStart = () => ({
  type: Actions.SET_SEND_IN_PROGRESS,
  payload: undefined,
});

export const setSendErrors = (errors: Error[]) => ({
  type: Actions.SET_SEND_ERRORS,
  payload: errors,
});

export const setSendSuccess = () => ({
  type: Actions.SET_SEND_SUCCESS,
  payload: undefined,
});

/* Verification actions */
export const setValidationStart = () => ({
  type: Actions.VALIDATE_IN_PROGRESS,
  payload: undefined,
});

export const setValidationErrors = (errors: Nullable<PepperValidationError>) => ({
  type: Actions.VALIDATE_ERRORS,
  payload: errors,
});

export const setValidationSuccess = () => ({
  type: Actions.VALIDATE_SUCCESS,
  payload: undefined,
});

/* Modal actions */
export const setModalIsOpen = (isOpen: boolean) => ({
  type: Actions.SET_MODAL_IS_OPEN,
  payload: isOpen,
});

export const setModalScreen = (modalScreen: AvailableModalActions) => ({
  type: Actions.SET_MODAL_SCREEN,
  payload: modalScreen,
});

/* Common actions */
export const resetPepper = () => ({
  type: Actions.RESET,
  payload: undefined,
});

export const reviewStart = () => ({
  type: Actions.REVIEW_START,
  payload: undefined,
});
